/* The Virtue of God — product page: gallery, sizes, other formats, "Try it on my wall". */
(function () {
  'use strict';

  function fmtOf(title) {
    var tl = title.toLowerCase(), c = tl.replace(/unstretched|unframed/g, '');
    if (/gallery[ -]wrapped|wrapped canvas|stretched|ready to hang/.test(c)) return 'Gallery-wrapped canvas';
    if (c.indexOf('framed') > -1) return 'Framed canvas';
    return 'Canvas print · unframed';
  }
  function norm(t) { return t.split('|')[0].toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function loadScript(src) {
    return new Promise(function (ok, bad) {
      if (!src) return ok();
      if (document.querySelector('script[data-vog-src="' + src + '"]')) return ok();
      var s = document.createElement('script'); s.src = src; s.async = true; s.setAttribute('data-vog-src', src);
      s.onload = function () { ok(); }; s.onerror = function () { bad(new Error('Could not load ' + src)); };
      document.head.appendChild(s);
    });
  }

  function init(root) {
    if (root.__vogPP) return; root.__vogPP = true;

    // Gallery
    var stage = root.querySelector('.vog-pp__stage'), stImg = stage && stage.querySelector('img'), vBox = stage && stage.querySelector('[data-vog-video]');
    function stopVideo() { if (vBox) { vBox.innerHTML = ''; vBox.hidden = true; } if (stage) stage.classList.remove('is-video'); if (stImg) stImg.hidden = false; }
    Array.prototype.forEach.call(root.querySelectorAll('.vog-pp__thumb'), function (b) {
      b.addEventListener('click', function () {
        var vid = b.getAttribute('data-video');
        if (vid) {
          var tpl = document.getElementById('VogVideo-' + vid);
          if (!tpl || !vBox) return;
          vBox.innerHTML = '';
          vBox.appendChild(tpl.content.cloneNode(true));
          vBox.hidden = false;
          if (stImg) stImg.hidden = true;
          stage.classList.remove('is-room');
          stage.classList.add('is-video');
          var v = vBox.querySelector('video'); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          Array.prototype.forEach.call(root.querySelectorAll('.vog-pp__thumb'), function (x) { x.classList.toggle('is-active', x === b); });
          return;
        }
        stopVideo();
        if (!stImg) return;
        stImg.src = b.getAttribute('data-src'); stImg.removeAttribute('srcset');
        stImg.alt = b.getAttribute('data-alt') || stImg.alt;
        stage.classList.toggle('is-room', b.getAttribute('data-room') === '1');
        Array.prototype.forEach.call(root.querySelectorAll('.vog-pp__thumb'), function (x) { x.classList.toggle('is-active', x === b); });
      });
    });

    var sp = root.querySelector('[data-vog-stageplay]');
    if (sp) sp.addEventListener('click', function () { var t = root.querySelector('.vog-pp__thumb.is-video'); if (t) t.click(); });

    // Sizes → price, compare-at price, URL, button state
    var price = root.querySelector('[data-vog-price]'), cmp = root.querySelector('[data-vog-cmp]'), btn = root.querySelector('[data-vog-add]');
    Array.prototype.forEach.call(root.querySelectorAll('.vog-pp__size input'), function (r) {
      r.addEventListener('change', function () {
        if (price) price.textContent = r.getAttribute('data-price');
        if (cmp) { var c = r.getAttribute('data-cmp'); cmp.hidden = !c; cmp.textContent = c || ''; }
        if (btn) { var ok = r.getAttribute('data-available') === 'true'; btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout'); }
        try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u.toString()); } catch (e) { console.error(e); }
      });
    });

    // Quantity
    var qi = root.querySelector('.vog-pp__qty input');
    Array.prototype.forEach.call(root.querySelectorAll('.vog-pp__qty button'), function (b) {
      b.addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + Number(b.getAttribute('data-q'))); });
    });

    // Other formats of the same photograph (shown only when they exist)
    var fb = root.querySelector('[data-vog-formats]');
    if (fb) {
      var key = norm(root.getAttribute('data-title') || ''), handle = root.getAttribute('data-handle');
      var list = fb.querySelector('.vog-pp__formats'), seen = {};
      var skip = (fb.getAttribute('data-skip') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      seen[fmtOf(root.getAttribute('data-title') || '')] = true;
      if (skip.indexOf(handle) > -1) fb = null;
    }
    if (fb) {
      var page = function (n) {
        return fetch('/products.json?limit=250&page=' + n).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) {
          var ps = d.products || [];
          ps.forEach(function (p) {
            if (p.handle === handle || norm(p.title) !== key || skip.indexOf(p.handle) > -1) return;
            var f = fmtOf(p.title); if (seen[f]) return; seen[f] = true;
            var min = Math.min.apply(null, p.variants.map(function (v) { return Number(v.price); }));
            var a = document.createElement('a'); a.className = 'vog-pp__fmt'; a.href = '/products/' + p.handle;
            a.innerHTML = esc(f) + '<em>From $' + min.toFixed(2) + '</em>';
            list.appendChild(a); fb.hidden = false;
          });
          if (ps.length === 250 && n < 8) return page(n + 1);
        });
      };
      page(1).catch(function (e) { console.error('Formats lookup failed', e); });
    }

    // Try it on my wall (reuses the Art Advisor tool; the photo never leaves the device)
    var wb = root.querySelector('[data-vog-wall-btn]'), host = root.querySelector('[data-vog-wall]');
    if (wb && host) {
      wb.addEventListener('click', function () {
        wb.disabled = true;
        loadScript(wb.getAttribute('data-catalog')).then(function () { return loadScript(wb.getAttribute('data-advisor')); }).then(function () {
          var h = root.getAttribute('data-handle');
          var p = (window.VOG_ADVISOR_CATALOG || []).filter(function (x) { return x.h === h; })[0];
          if (!p) p = { h: h, t: root.getAttribute('data-short') || '', i: (root.getAttribute('data-image') || '').split('?')[0] };
          var sel = root.querySelector('.vog-pp__size input:checked'), lbl = sel ? sel.getAttribute('data-size') : '';
          var m = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(lbl || ''), z = null;
          if (m) {
            var a = Number(m[1]), b = Number(m[2]);
            (p.z || []).forEach(function (s) { if (!z && Math.min(s[0], s[1]) === Math.min(a, b) && Math.max(s[0], s[1]) === Math.max(a, b)) z = [s[0], s[1]]; });
            if (!z) z = Number(root.getAttribute('data-aspect')) >= 1 ? [Math.max(a, b), Math.min(a, b)] : [Math.min(a, b), Math.max(a, b)];
          }
          if (!z) z = p.z && p.z[0] ? [p.z[0][0], p.z[0][1]] : [16, 20];
          if (typeof window.VOGWall !== 'function') throw new Error('Wall tool missing');
          host.hidden = false;
          window.VOGWall(host, p, z);
          host.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }).catch(function (e) { console.error('Try it on my wall failed', e); }).then(function () { wb.disabled = false; });
      });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-vog-pp]'), function (r) { try { init(r); } catch (e) { console.error('Product page script failed', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
